export enum PartnerTransferSection {
  PartnerTransfer = 'PartnerTransfer',
  Investments = 'Investments',
  Expenses = 'Expenses',
  Income = 'Income',
  Fees = 'Fees',
  LinkedCapitalActions = 'LinkedCapitalActions',
  GeneralCapitalActions = 'GeneralCapitalActions',
  AdvanceSubscriptions = 'AdvanceSubscriptions',
  Summary = 'Summary',
}

export enum PartnerTransferTypes {
  PartnerTransfer = 'partnerTransfer',
}
